import { render, staticRenderFns } from "./createOrder3.vue?vue&type=template&id=dd6e204a&scoped=true&"
import script from "./createOrder3.vue?vue&type=script&lang=js&"
export * from "./createOrder3.vue?vue&type=script&lang=js&"
import style0 from "./createOrder3.vue?vue&type=style&index=0&id=dd6e204a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6e204a",
  null
  
)

export default component.exports